<template>
  <v-list v-if="formResponse">
    <v-list-item
      v-for="(question, index) in formResponse.formQuestionList"
      :key="question.id"
      two-line
    >
      <v-list-item-icon> {{ index + 1 }}. </v-list-item-icon>
      <v-list-item-content>
        <div class="text-subtitle-2 pt-1 pr-5" style="white-space: pre-line">
          {{ question.question }}
        </div>
        <div
          v-if="question.questionType === 'SIGNATURE' && formatAnswer(question)"
        >
          <v-img
            max-height="150"
            aspect-ratio="2"
            contain
            :src="formatAnswer(question)"
          />
        </div>
        <div v-else class="text-body-2 py-2 pr-5" style="white-space: pre-line">
          {{ formatAnswer(question) }}
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { formUtil } from "@/store/util/formUtils.js";

export default {
  props: {
    submissionId: {
      type: Number,
      required: false,
    },
    submission: {
      type: Object,
      required: false,
    },
  },
  data: () => ({
    formUtil,
    formResponse: null
  }),
  async mounted(){
    if(this.submission){
      this.formResponse = this.submission;
    }
    else if(this.submissionId){
      this.formResponse = await this.lookupFormResponseWithId(this.submissionId);
      debugger;
    }
  },
  methods: {
    formatAnswer(question) {
      if (question.formAnswerList && question.formAnswerList.length > 0) {
        const textMode = true;
        const answers = this.formUtil.convertFormAnswerList(question, textMode);
        return answers;
      } else {
        return "";
      }
    },
    async lookupFormResponseWithId(id) {
      const params = { id };
      return await this.$axios.get("/form/form-with-answer", { params }).then((resp) => {
        return resp.data.data;
      });
    },
  },
};
</script>

<style>
</style>